import {DateTime} from "luxon"

export const doctorFilials = {
  state: {
    doctorFilialsList: []
  },
  mutations: {
    setDoctorFilialsLists(state, val) {
      state.doctorFilialsList = val
    },
  },
  getters: {
    doctorFilialsList(state) {
      return state.doctorFilialsList
    },
  },
  actions: {
  }
}